const autoNgTemplateLoaderTemplate1 = require('./coach-profile.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';

(function () {
    angular
        .module('app.coachProfile', [])
        .component('coachProfile', {
            templateUrl: autoNgTemplateLoaderTemplate1,
            controller: 'CoachProfileController',
            controllerAs: 'vm',
        })
        .config(coachProfileConfig);

    coachProfileConfig.$inject = ['$routeProvider'];

    function coachProfileConfig($routeProvider) {
        $routeProvider
            .when('/coach-profile', {
                disableCache: true,
                template: '<coach-profile></coach-profile>',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: null,
                    breadcrumbs: [
                        { label: 'Coach Profile', icon: NAVIGATION_ICON.ASSIGNMENT_IND }
                    ]
                }
            })
    }
})();
